import { render, staticRenderFns } from "./collectionPlans.vue?vue&type=template&id=c23b2df0"
import script from "./collectionPlans.vue?vue&type=script&lang=js"
export * from "./collectionPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports